<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <!-- <el-col :lg="8" :xl="8" style="margin:10px 0px -10px">
                    <el-form-item label="发往地">
                    <el-input v-model="address" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="prodTaskDetailSearch.whCode" placeholder="请选择" filterable clearable="clearable" remote :remote-method="remoteMethod">
                            <el-option v-for="(item, index) in warehouseList" :key="index" :label="item.whCode" :value="item.whCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="成品编号" class="EL-Form-Item">
                        <!-- <el-select v-model="prodTaskDetailSearch.matCode" placeholder="请选择" filterable clearable="clearable" remote :remote-method="remoteMethod">
                            <el-option v-for="(item, index) in matCodes" :key="index" :label="item.mtCode" :value="item.mtCode">
                            </el-option>
                        </el-select> -->
                        <el-input v-model="prodTaskDetailSearch.matCode" placeholder="请输入" />
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input v-model="prodTaskDetailSearch.boxBarcode" placeholder="请输入" />
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="巷道" class="EL-Form-Item">
                        <el-select multiple collapse-tags v-model="endPointList" filterable clearable="clearable">
                            <el-option v-for="(item, index) in sysPointRouterData.data" :key="index" :label="item.prRealCode" :value="item.prCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="clickSelectProdTaskDetail()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="setProdTaskDetailSearch()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="配送方式" class="EL-Form-Item">
                        <el-select v-model="prodTaskDetailSearch.delivery" filterable clearable="clearable">
                            <el-option value="10" label="AGV搬运"></el-option>
                            <el-option value="20" label="人工搬运"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="搬运状态" class="EL-Form-Item">
                        <el-select v-model="prodTaskDetailSearch.status" filterable clearable="clearable">
                            <el-option value="EXECUTE" label="搬运中"></el-option>
                            <el-option value="DELIVERY" label="待确认完成"></el-option>
                            <el-option value="COMPLETE" label="待装车"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱数" class="EL-Form-Item">
                        <el-input v-model="prodTaskDetailSearch.boxNumber" disabled />
                    </el-form-item>
                </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="成品装车单">
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M9_B1'" @click="openAddressDialog">
                    装车
                </el-button>
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M9_B2'" @click="updateProdTaskDetail">
                    确认搬运完成
                </el-button>
                <el-button class="btn-t-delete" v-authority="'BACK_MENU3_M9_B3'" @click="deleteProdTaskDetail">
                    删除
                </el-button>
                <el-button v-authority="'BACK_MENU3_M9_B4'" @click="rePrintBarcode()" class="btn-t-edit">标签打印</el-button>
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M9_B5'" @click="showProductPullDialog">
                    历史装车记录
                </el-button>
                <!-- <el-button class="btn-t-edit"  @click="untieOccupyClick">
                    解绑和占用
                </el-button> -->
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M9_B6'" @click="openSysPointRouterDialog">
                    库位详情
                </el-button>
                <!-- <el-button class="btn-t-edit" @click="printProduct()">
                    单据打印
                </el-button>-->
                <el-button :loading="downLoading" class="btn-t-edit" type="primary" @click="downLoadFile()" v-authority="'BACK_MENU3_M9_B7'">
                    导出EXCEl
                </el-button>
            </plabel>
            <h-table :headerCellStyle="prodTaskDetailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.64)" @pageChange="getProdTaskDetailList" :data="prodTaskDetailData.data" pagination :nowPage.sync="prodTaskDetailData.pageNum" :pageSize.sync="prodTaskDetailData.pageSize" :total.sync="prodTaskDetailData.total" @selectionChange="checkTableMain">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="通道编号" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="成品编号" prop="matCode" align="center">
                </el-table-column>
                <!-- <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column> -->
                <el-table-column label="成品数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="箱号" prop="boxBarcode" align="center">
                </el-table-column>
                <el-table-column label="工单编号" prop="opCode" align="center">
                </el-table-column>
                <el-table-column label="围板箱编码" prop="packCode" align="center">
                </el-table-column>
                <el-table-column label="包装方式" prop="packageCode" align="center">
                </el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                </el-table-column>
                <!-- <el-table-column label="工厂编号" prop="fcCode" align="center">
                </el-table-column> -->
                <el-table-column label="创建时间" prop="createTime" align="center">
                </el-table-column>
                <!-- <el-table-column label="更新时间" prop="updateTime" align="center">
                </el-table-column> -->

                <el-table-column label="搬运起点" prop="startPoint" align="center">
                </el-table-column>
                <el-table-column label="搬运终点" prop="endPoint" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.endPoint == '1${02}'">一期成品二层箱</span>
                        <span v-if="scope.row.endPoint == '2${02}'">一期成品一层箱</span>
                        <span v-if="scope.row.endPoint == '3${02}'">大托盘</span>
                        <span v-if="scope.row.endPoint == '4${02}'">二期蓝色一层箱</span>
                        <span v-if="scope.row.endPoint == '5${02}'">二期成品二层箱</span>
                        <span v-if="scope.row.endPoint == '6${02}'">二期成品一层箱</span>
                    </template>
                </el-table-column>
                <el-table-column label="配送方式" prop="delivery" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.delivery == '10'">AGV配送</span>
                        <span v-if="scope.row.delivery == '20'">人工配送</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="status" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 'CREATE'">创建</span>
                        <span v-if="scope.row.status == 'COMPLETE'">待装车</span>
                        <span v-if="scope.row.status == 'DELIVERY'">待确认完成</span>
                        <span v-if="scope.row.status == 'EXECUTE'">搬运中</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button @click="deleteProdTaskDetail(scope.row.tdId)" class="btn-t-delete">删除</el-button>
                    </template>
                </el-table-column> -->
            </h-table>
        </box>

        <!-- 成品装车历史记录 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.8,0.9)" title="历史装车记录" :visible.sync="insertProductPullDialog" :close="closeProductPullDialog">
            <div style="font-size: 16px">
                <el-form label-position="right" label-width="80px" class="EL-Form">
                    <!-- <el-col :lg="5" :xl="5">
                        <el-form-item label="来源通道" class="EL-Form-Item">
                            <el-select v-model="ProductPullDataSearch.whCode" placeholder="请选择" clearable="clearable">
                                <el-option v-for="item in warehouseList" :key="item.whId" :label="item.whCode+'-'+item.whName" :value="item.whCode">{{item.whCode}}-{{item.whName}}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="装车单号" class="EL-Form-Item">
                            <el-input v-model="ProductPullDataSearch.ppCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="5" :xl="5">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <el-input v-model="ProductPullDataSearch.matCode" placeholder="请输入" @change="saveSearch()"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="发往地" class="EL-Form-Item">
                            <el-input v-model="ProductPullDataSearch.address" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="开始日期" class="EL-Form-Item">
                            <el-date-picker v-model="ProductPullDataSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="ProductPullDataSearch.fcCode">
                        <el-form-item label="结束日期" class="EL-Form-Item">
                            <el-date-picker v-model="ProductPullDataSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="4" :xl="4">
                        <el-form-item class="btn-edit-delete EL-Form-Item">
                            <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M9_B4'" @click="printProduct()">
                                单据打印
                            </el-button>
                            <el-button :loading="downloadChooseLoading" class="btn-t-edit" type="primary" @click="downLoadChooseFile2()" v-authority="'BACK_MENU3_M9_B7'" >
                                导出EXCEl
                            </el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
                <h-table :headerCellStyle="ProductPullData.headerCellStyle" :style="$popups.harvestRecordStyle(0.73)" @pageChange="getProductPullList" :data="ProductPullData.data" pagination :nowPage.sync="ProductPullData.pageNum" :pageSize.sync="ProductPullData.pageSize" :total.sync="ProductPullData.total" @selectionChange="selectAllProductPull">
                    <el-table-column type="selection" align="center"> </el-table-column>
                    <!-- <el-table-column label="来源通道" prop="whCode" align="center">
                    </el-table-column> -->
                    <el-table-column label="装车单号" prop="ppCode" align="center">
                    </el-table-column>
                    <el-table-column label="发往地" prop="address" align="center">
                    </el-table-column>
                    <el-table-column label="创建时间" prop="createTime" align="center" width="180px">
                    </el-table-column>
                    <el-table-column label="操作人" prop="person" align="center">
                    </el-table-column>
                    <!-- <el-table-column label="操作人工号" prop="personNumber" align="center">
                    </el-table-column> -->
                    <el-table-column label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button class="btn-t-select" @click="showProductPullDetailDialog(scope.row.ppCode)">明细</el-button>
                        </template>
                    </el-table-column>
                </h-table>
            </div>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeProductPullDialog()" class="btn-t-info">关 闭</el-button>
                <!-- <el-button class="btn-t-edit" @click="openAddressDialog()">确 定</el-button> -->
            </span>
        </el-dialog>

        <!-- 发往地 -->
        <el-dialog class="unpacking-dialog" title="发往地" :visible.sync="addressDialog" width="20%">
            <div style="font-size: 16px">
                <el-form label-position="right" label-width="80px" class="EL-Form" style="height: 5vh">
                    <el-col :lg="24" :xl="24">
                        <el-form-item label="发往地" class="EL-Form-Item">
                            <el-select v-model="address" filterable clearable="clearable" placeholder="请选择" remote :remote-method="remoteMethodAddress">
                                <el-option value="大连仓库" label="大连仓库"></el-option>
                                <el-option value="上海仓库" label="上海仓库"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeAddressDialog" type="info" class="btn-t-info">取 消</el-button>
                <el-button :loading="insertProductPulls" @click="insertProductPull" type="primary" class="btn-t-edit">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 成品装车详情 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.8,0.9)" title="成品装车详情" :visible.sync="productPullDetailDialog">
            <h-table :headerCellStyle="productPullDetailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.74)" :data="productPullDetailData.data">
                <!-- <el-table-column type="selection" align="center"> </el-table-column> -->
                <el-table-column label="成品编号" prop="matCode" align="center">
                </el-table-column>
                <!-- <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column> -->
                <el-table-column label="成品数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="毛重" prop="pwWeight" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.pwWeight != null || scope.row.pwWeight != ''">

                        </div>
                        <div v-else>
                            {{scope.row.matQuan * scope.row.pwWeight}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="通道" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="箱号" prop="boxBarcode" align="center">
                </el-table-column>
                <el-table-column label="装车单号" prop="ppCode" align="center">
                </el-table-column>
                <el-table-column label="工单编号" prop="opCode" align="center">
                </el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                </el-table-column>
                <!-- <el-table-column label="围板箱编码" prop="packCode" align="center">
                </el-table-column>
                <el-table-column label="包装方式" prop="packageCode" align="center">
                </el-table-column> -->
                <el-table-column label="创建时间" prop="createTime" align="center">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="returnClose" type="info" class="btn-t-info">关 闭</el-button>
            </div>
        </el-dialog>

        <!-- 库位详情框 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.8,0.9)" title="库位详情" :visible.sync="sysPointRouterDialog" @close="closeSysPointRouterDialog">
            <div style="font-size: 16px;float:right;margin: 5px 0px">
                <el-button class="btn-t-edit" @click="updateChannelCodeOccupyFlag">
                    占用
                </el-button>
                <el-button class="btn-t-delete" @click="productUnboundContainer">
                    解绑
                </el-button>
            </div>
            <h-table :headerCellStyle="sysPointRouterData.headerCellStyle" :style="$popups.harvestRecordStyle(0.7)" :data="sysPointRouterData.data" @selectionChange="checkSysPointList">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column label="库位类型" prop="spCode" align="center">
                </el-table-column>
                <el-table-column label="库位实际名称" prop="prRealCode" align="center">
                </el-table-column>
                <el-table-column label="库位编号" prop="prCode" align="center">
                </el-table-column>
                <el-table-column label="agv库位编号" prop="agvCode" align="center">
                </el-table-column>
                <el-table-column label="是否占用" prop="occupyFlag" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.occupyFlag == true">是</span>
                        <span v-if="scope.row.occupyFlag == false">否</span>
                    </template>
                </el-table-column>
                <el-table-column label="箱体类型" prop="prBoxType" align="center">
                </el-table-column>
                <!-- <el-table-column label="巷道编号" prop="channelCode" align="center">
                </el-table-column> -->
                <el-table-column label="更新时间" prop="updateTime" align="center">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeSysPointRouterDialog" type="info" class="btn-t-info">关 闭</el-button>
            </div>
        </el-dialog>

        <!-- 打印 -->
        <el-dialog title="打印" :visible.sync="printShow" width="1200px" :close-on-click-modal="false" style="height:100%">
            <div class="divdiv">
                <v-print :doPrint.sync="print">
                    <div id="demo" class="demo11">
                        <div class="div">
                            <table border="1" cellpadding="0" cellspacing="0">
                                <thead style="display:table-header-group">
                                    <tr>
                                        <th style="width:170px">型号</th>
                                        <th>发往地</th>
                                        <th style="width:160px">箱码</th>
                                        <th>装箱数量</th>
                                        <th>毛重</th>
                                    </tr>
                                </thead>
                                <tr v-for="(item, index) in printData" :key="index">
                                    <td>{{item.matCode}}</td>
                                    <td>{{item.address}}</td>
                                    <td>{{item.boxBarcode}}</td>
                                    <td>{{item.matQuan}}</td>
                                    <td>{{item.pwWeight}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="div1">
                            <div style="width:300px;">打印时间：{{printTime}}</div>
                            <div></div>
                            <div>日期：</div>
                            <div>{{printDate}}</div>
                            <div style="margin-top: 20px;">发货汇总</div>
                            <table cellpadding="0" cellspacing="0">
                                <tr>
                                    <th style="width:200px;">型号</th>
                                    <th>箱数</th>
                                    <th>数量</th>
                                    <th>毛重</th>
                                </tr>
                                <tr v-for="(item, index) in printCollect" :key="index">
                                    <td style="width:200px;">{{item.matCode}}</td>
                                    <td>{{item.boxBarcode}}</td>
                                    <td>{{item.matQuan}}</td>
                                    <td>{{item.pwWeight}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </v-print>
            </div>
            <div style="margin-top: 50px;height:70px">
                <el-button class="btn-t-edit" @click="(printShow = false), (printList = [])">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
    import vPrint from 'syl-vue-printer'
    import moment from "moment";
    export default {
        name: "FinishedProductLoad",
        components: {
            vPrint
        },
        data() {
            return {
                printData: [], //打印数据
                printCollect: [], //数据汇总
                print: false,
                printShow: false,
                printObj: {
                    id: "demo",
                    popTitle: "",
                },
                printDate: "",
                printTime: moment(new Date).format("yyyy-MM-DD"),

                ProductPullData: {
                    data: [],
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                ProductPullDataSearch: {
                    fcCode: localStorage.getItem("fcCode") || "",
                    whCode: localStorage.getItem("whCode") || "",
                    ppCode: "",
                    address: "",
                    matCode: "",
                    matName: "",
                    boxBarcode: "",
                    date: [],
                },
                whCodeId: "",
                productPullDetailData: {
                    data: [],
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                prodTaskDetailData: {
                    data: [],
                    pageNum: 1,
                    pageSize: 100,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                prodTaskDetailSearch: {
                    fcCode: localStorage.getItem("fcCode"),
                    matCode: "",
                    boxBarcode: "",
                    endPoint: "",
                    status: "COMPLETE",
                    taskType: "10",
                    delivery: "",
                    whCode: "",
                    boxNumber: "",
                },
                sysPointRouterData: {
                    data: [],
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //新增成品装车记录窗口
                insertProductPullDialog: false,
                //明细成品装车记录窗口
                productPullDetailDialog: false,
                //成品装车号
                ppCode: "",
                //成品装车物料
                productPullDetail: "",
                //成品装车库位编号
                laCode: "",
                //工厂编号
                fcCode: localStorage.getItem("fcCode") || "",
                //操作人
                person: localStorage.getItem("user"),
                //操作人工号
                personNumber: localStorage.getItem("empNumber"),
                whCode: "",
                //来源通道集合
                whCodeList: [],
                warehouseList: [],
                //发往地
                address: "",
                //装车单复选项
                checkList: [],
                //复选项
                checkListMain: [],
                //选中任务集合
                prodTaskDetailList: [],

                //库位详情框
                sysPointRouterDialog: false,
                // 解绑和占用弹出框
                untieOccupyDialog: false,
                //库位多选集合
                checkSysPointRouter: [],

                downloadLoading: false, //下载中
                insertProductPulls: false,
                //解绑数量变量
                unboundContainerCount: 0,
                //物料条件集合
                matCodes: [],
                //终点集合
                endPointList: [],
                //发往地弹窗
                addressDialog: false,
                //成品箱选择导出
                downloadChooseLoading: false,
                downLoading: false,

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            popups() {
                return {
                    overflow: 'hidden',
                    transform: 'translate(-50%, 0)',
                    left: window.innerWidth * 0.5 + "px",
                    top: window.innerHeight * 0.38 + "px",
                    width: window.innerWidth * 0.6 + "px",
                    height: window.innerHeight * 0.22 + "px",
                    "min-width": window.innerWidth * 0.6 + "px",
                    "min-height": window.innerHeight * 0.22 + "px",
                }
            },
            ProductPullDataSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectList(newVal);
                    }, 1000);
                },
                deep: true,
            },
            prodTaskDetailSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectProdTaskDetail(newVal);
                    }, 1000);
                },
                deep: true,
            },
            endPointList: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectProdTaskDetail(newVal);
                    }, 1000);
                },
                deep: true,
            }
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.ProductPullDataSearch.date[0]) {
                            return time.getTime() < new Date(_this.ProductPullDataSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.ProductPullDataSearch.date[1]) {
                            return time.getTime() > new Date(_this.ProductPullDataSearch.date[1]);
                        }
                    }
                }
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.clickSelectList()
                }, 1000)
            },
            /**
             * 目的地
             */
            remoteMethodAddress(query) {
                this.address = query;
            },
            /**
             * 关闭发往地弹窗
             */
            closeAddressDialog() {
                this.address = "";
                this.addressDialog = false;
            },
            /**
             * 打开发往地弹窗
             */
            openAddressDialog() {
                var statusFlag = false;
                this.checkListMain.forEach((item) => {
                    console.log(item)
                    if (item.status != 'COMPLETE') {
                        statusFlag = true;
                    }
                })
                if (this.checkListMain.length < 1) {
                    this.$message({
                        message: "请至少勾选一个成品装车任务！",
                        type: "warning",
                    });
                    return;
                } else if (statusFlag) {
                    this.$message({
                        message: "请选择搬运完成的成品进行装车，对人工搬运的确认搬运完成！",
                        type: "warning",
                    });
                    return;
                } else {
                    console.log(statusFlag);
                    this.address = "大连仓库";
                    this.addressDialog = true;
                }
            },
            /**
             * 清空新增成品装车条件
             */
            setProdTaskDetailSearch() {
                this.prodTaskDetailSearch = {
                        fcCode: localStorage.getItem("fcCode"),
                        matCode: "",
                        boxBarcode: "",
                        endPoint: "",
                        status: "COMPLETE",
                        taskType: "10",
                        delivery: "",
                        whCode: "",
                        boxNumber: "",
                    },
                    this.endPointList = []
            },
            /**
             * 远程搜索物料编号
             */
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;

                    this.prodTaskDetailSearch.matCode = query;
                    this.getSysMaterial();

                    setTimeout(() => {
                        this.loading = false;
                        if (this.matCodes != undefined) {
                            this.matCodes = this.matCodes.filter(item => {
                                return item.mtCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.matCodes = [];
                }
            },
            /**
             * 根据工厂编号查询所有的物料编号
             */
            getSysMaterial() {
                this.$http
                    .request({
                        url: "/api/material/getMaterials",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || null,
                            mtCode: this.mtCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.matCodes = resp.data.list;
                            this.logRemarks = "checkTask：查询物料编号操作成功";
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                            this.logRemarks = "checkTask：查询物料编号操作失败";
                        }
                        //this.logContent = "sckCodes：" + sckCodes;
                        this.systemLog();
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 确认人工搬运完成
             */
            updateProdTaskDetail() {
                var flag = false; //不能对agv搬运已完成的进行确认人工搬运
                this.checkListMain.forEach((item) => {
                    if (item.delivery == '10' && item.status == 'COMPLETE') {
                        flag = true;
                    }
                })
                if (this.checkListMain.length < 1) {
                    this.$message({
                        message: "请至少勾选一个人工搬运或AGV搬运进行中的记录！",
                        type: "warning",
                    });
                    return;
                } else if (flag) {
                    this.$message({
                        message: "不能对已经搬运完成的AGV搬运记录进行确认搬运完成操作！",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm("是否确认人工搬运完成?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            //如果是agv正在搬运中出现问题
                            this.$http
                                .request({
                                    url: "/api/prodTask/updateProdTaskDetailStatus",
                                    method: "PUT",
                                    showLoading: true,
                                    data: this.checkListMain,
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.getProdTaskDetailList();
                                        this.$message({
                                            message: "人工搬运完成！",
                                            type: "success",
                                        });
                                    } else {
                                        this.$message({
                                            message: resp.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    this.$message({
                                        message: "操作失败",
                                        type: "warning",
                                    });
                                });
                        }).catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });

                }
            },
            /**
             * 解绑巷道
             */
            productUnboundContainer() {
                var flag = false;
                this.checkSysPointRouter.forEach((item) => {
                    if (!item.occupyFlag) {
                        flag = true;
                    }
                })
                if (this.checkSysPointRouter.length < 1) {
                    this.$message({
                        message: "请勾选一个巷道再进行解绑操作！",
                        type: "warning",
                    });
                    return;
                } else if (flag) {
                    this.$message({
                        message: "选中的巷道已未占用的无需解绑！",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm("是否确认解绑巷道?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.checkSysPointRouter.forEach((item) => {
                                var length = this.checkSysPointRouter.length;
                                this.$http
                                    .request({
                                        url: "/agv/pointrouter/productUnboundContainer",
                                        method: "POST",
                                        showLoading: true,
                                        params: {
                                            prCode: item.prCode,
                                        }
                                    })
                                    .then((resp) => {
                                        if (resp.status == 100) {
                                            this.getSysPointRouterAutoArea();
                                            this.unboundContainerCount++;
                                            if (length == this.unboundContainerCount) {
                                                this.unboundContainerCount = 0;
                                                this.$message({
                                                    message: "解绑成功",
                                                    type: "success",
                                                });
                                            }
                                        } else {
                                            this.$message({
                                                message: resp.message,
                                                type: "error",
                                            });
                                        }
                                    })
                                    .catch((error) => {
                                        this.$message({
                                            message: "操作失败",
                                            type: "warning",
                                        });
                                    });
                            })

                        }).catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });

                }
            },
            /**
             * 占用可用的成品区巷道
             */
            updateChannelCodeOccupyFlag() {
                var flag = false;
                this.checkSysPointRouter.forEach((item) => {
                    if (item.occupyFlag) {
                        flag = true;
                    }
                })
                if (this.checkSysPointRouter.length < 1) {
                    this.$message({
                        message: "请至少勾选一个巷道！",
                        type: "warning",
                    });
                    return;
                } else if (flag) {
                    this.$message({
                        message: "选中的巷道已未占用的无需解绑！",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm("是否确认占用巷道?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.$http
                                .request({
                                    url: "/api/sysPointRouter/updateChannelCodeOccupyFlag",
                                    method: "PUT",
                                    showLoading: true,
                                    data: this.checkSysPointRouter,
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.getSysPointRouterAutoArea();
                                        this.$message({
                                            message: "占用成功",
                                            type: "success",
                                        });
                                    } else {
                                        this.$message({
                                            message: resp.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    this.$message({
                                        message: "操作失败",
                                        type: "warning",
                                    });
                                });
                        }).catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });

                }
            },
            /**
             * 打开库位详情窗口
             */
            openSysPointRouterDialog() {
                this.getSysPointRouterAutoArea();
                this.sysPointRouterDialog = true;
            },
            /**
             * 关闭库位详情窗口
             */
            closeSysPointRouterDialog() {
                this.sysPointRouterDialog = false;
            },
            /**
             * 获取成品区所有库位详情信息
             */
            getSysPointRouterAutoArea() {
                this.$http
                    .request({
                        url: "/api/sysPointRouter/getSysPointRouterAutoArea",
                        method: "GET",
                        params: {
                            fcCode: this.fcCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.sysPointRouterData.data = resp.data.list || [];
                            this.sysPointRouterData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 删除成品单
             */
            deleteProductPull() {
                if (this.checkList.length < 1) {
                    this.$message({
                        message: "请至少勾选一个成品装车单！",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm("是否确认删除该成品装车单?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.$http
                                .request({
                                    url: "/api/SplitMergeMatChange/deleteProductPull",
                                    method: "DELETE",
                                    data: this.checkList
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.$message({
                                            message: "操作成功",
                                            type: "success",
                                        });
                                        this.getProductPullList();
                                    }
                                }).catch((error) => {
                                    this.$message({
                                        message: "操作失败",
                                        type: "warning",
                                    });
                                })
                        }).catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });

                }
            },
            // 获取所有未处理的成品任务
            getProdTaskDetailList() {
                let endPoint = "";
                this.endPointList.forEach((item) => {
                    endPoint += item + ","
                })
                this.$http
                    .request({
                        url: "/api/prodTask/getProdTaskDetail",
                        method: "GET",
                        params: {
                            pageNum: this.prodTaskDetailData.pageNum || null,
                            pageSize: this.prodTaskDetailData.pageSize || null,
                            fcCode: this.prodTaskDetailSearch.fcCode || null,
                            matCode: this.prodTaskDetailSearch.matCode || null,
                            boxBarcode: this.prodTaskDetailSearch.boxBarcode || null,
                            //endPoint: this.prodTaskDetailSearch.endPoint || null,
                            endPoint: endPoint || null,
                            status: this.prodTaskDetailSearch.status || null,
                            taskType: this.prodTaskDetailSearch.taskType || null,
                            delivery: this.prodTaskDetailSearch.delivery || null,
                            whCode: this.prodTaskDetailSearch.whCode || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.prodTaskDetailData.data = resp.data.list;
                            this.prodTaskDetailData.total = resp.data.total;
                            this.prodTaskDetailSearch.boxNumber = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 删除成品未装车任务明细
             */
            deleteProdTaskDetail() {
                var tdIds = "";
                this.checkListMain.forEach((item)=>{
                    tdIds += item.tdId + ",";
                })
                this.$confirm("是否确认删除该成品任务明细?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/SplitMergeMatChange/deleteProdTaskDetailCreate",
                                method: "DELETE",
                                params: {
                                    tdIds: tdIds,
                                    fcCode: this.fcCode,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.getProdTaskDetailList();
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: "操作失败",
                                        type: "warning",
                                    });
                                }
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            chooseDTChange() {
                this.$forceUpdate();
            },
            //删除成品装车的物料
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            // 点击查询按钮 重置页号
            clickSelectList(newVal) {
                this.ProductPullData.pageNum = 1;
                this.getProductPullList(newVal);
            },
            clickSelectProdTaskDetail() {
                this.prodTaskDetailData.pageNum = 1;
                this.getProdTaskDetailList();
            },
            /**
             * 成品装车数据记录
             */
            getProductPullList: function() {
                // if (this.ProductPullDataSearch.whCode == "") {
                //     this.whCodeId = localStorage.getItem("whCode") || "";
                // } else {
                //     this.whCodeId = this.ProductPullDataSearch.whCode;
                // }

                this.$http
                    .request({
                        url: "/api/SplitMergeMatChange/getProductPull",
                        method: "GET",
                        params: {
                            pageNum: this.ProductPullData.pageNum,
                            pageSize: this.ProductPullData.pageSize,
                            // person: localStorage.getItem("user") || "",
                            fcCode: this.ProductPullDataSearch.fcCode || null,
                            ppCode: this.ProductPullDataSearch.ppCode || null,
                            //whCode: this.ProductPullDataSearch.whCode,
                            address: this.ProductPullDataSearch.address || null,
                            matCode: this.ProductPullDataSearch.matCode || null,
                            matName: this.ProductPullDataSearch.matName || null,
                            boxBarcode: this.ProductPullDataSearch.boxBarcode || null,
                            beginTime: this.ProductPullDataSearch.date ?
                                this.ProductPullDataSearch.date[0] : null,
                            endTime: this.ProductPullDataSearch.date ?
                                this.ProductPullDataSearch.date[1] : null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.ProductPullData.data = resp.data.list || [];
                            this.ProductPullData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 新增成品装车数据记录
             */
            insertProductPull: function() {
                if (this.address == "") {
                    this.$message({
                        message: "请输入发往地",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm("是否确认开始成品装车?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.insertProductPulls = true;
                            this.$http
                                .request({
                                    url: "/api/SplitMergeMatChange/insertProductPull",
                                    method: "POST",
                                    showLoading: true,
                                    params: {
                                        person: this.person || null,
                                        personNumber: this.personNumber || null,
                                        address: this.address || null,
                                    },
                                    data: this.checkListMain,
                                })
                                .then((resp) => {
                                    this.logContent =
                                        "fcCode：" +
                                        localStorage.getItem("fcCode") || "" +
                                        "\t" +
                                        "laCode" +
                                        this.laCode;
                                    if (resp.status == 100) {
                                        this.addressDialog = false
                                        this.insertProductPullDialog = false;
                                        this.setProdTaskDetailSearch();
                                        this.address = "";
                                        this.getProductPullList();
                                        this.$message({
                                            message: "新增成品装车订单成功!",
                                            type: "success",
                                        });
                                        this.logRemarks = "splitMergeMatChange：新增成品装车订单成功";
                                    } else {
                                        this.$message({
                                            message: resp.message,
                                            type: "error",
                                        });
                                        this.logRemarks = "splitMergeMatChange：新增成品装车订单失败";
                                    }
                                    this.insertProductPulls = false;
                                    this.systemLog();
                                });
                        })
                        .catch(() => {
                            this.insertProductPulls = false;
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            },
            /**
             * 获取成品装车明细数据记录
             */
            getProductPullDetails() {
                this.$http
                    .request({
                        url: "/api/SplitMergeMatChange/getProductPullDetail",
                        method: "GET",
                        params: {
                            ppCode: this.ppCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.productPullDetailData.data = resp.data.list || [];
                            this.productPullDetailData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 根据工厂编号查询所有的来源通道
             */
            getSysWarehouseAll() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            /**
             * 明细成品装车窗口
             */
            showProductPullDetailDialog(ppCode) {
                this.productPullDetailDialog = true;
                this.ppCode = ppCode;
                this.getProductPullDetails();
            },
            /**
             * 关闭成品装车明细窗口
             */
            returnClose() {
                this.productPullDetailDialog = false;
            },
            /**
             * 新增成品装车窗口
             */
            showProductPullDialog() {
                //this.getSysMaterial();
                //this.getSysPointRouterAutoArea();
                this.insertProductPullDialog = true;
                //this.prodTaskDetailData.pageNum = 1;
                this.getProductPullList()
                //this.getSysWarehouseAll();
                //this.getProdTaskDetailList();
            },
            /**
             * 关闭成品装车窗口
             */
            closeProductPullDialog() {
                this.ProductPullReset();
                this.insertProductPullDialog = false;
                //this.prodTaskDetailData.pageNum = 1;
                // this.productPullDetailList.data = [];
                //this.productPullDetail = "";
                //this.whCode = "";
                //this.endPointList = [];
                //this.setProdTaskDetailSearch();
            },
            /* 点击解绑和占用按钮查询数据 */
            untieOccupyClick() {
                this.untieOccupyDialog = true;
                this.$http
                    .request({
                        url: "/api/sysLineRouter/getSysLineRouterAllByWhCode",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: localStorage.getItem("whCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            console.log(resp);
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            /**
             * 回车提交
             */
            // submit() {
            //     var detail = this.productPullDetail.split("-");
            //     var flag = true;
            //     if (detail.length != 4) {
            //         this.$message({
            //             message: "成品装车的物品格式不对！(T-箱号-物料编号-数量)",
            //             type: "warning",
            //         });
            //         return;
            //     }
            //     //判断箱号是否重复输入
            //     this.productPullDetailList.data.forEach((item) => {
            //         if (item.boxBarcode == detail[1]) {
            //             flag = false;
            //             this.$message({
            //                 message: "成品装车的物品箱号相同",
            //                 type: "warning",
            //             });
            //             return;
            //         }
            //     })
            //     if (flag) {
            //         this.productPullDetailList.data.push({
            //             t: detail[0],
            //             boxBarcode: detail[1],
            //             matCode: detail[2],
            //             matQuan: detail[3],
            //         });
            //         this.productPullDetail = "";
            //     }

            //},
            /**
             * 多选
             */
            selectAllProductPull(val) {
                this.checkList = val;
            },
            /**
             * 多选
             */
            checkTableMain(val) {
                this.checkListMain = val;
            },
            /**
             * 多选
             */
            checkSysPointList(val) {
                this.checkSysPointRouter = val;
            },
            //清空
            ProductPullReset() {
                this.ProductPullDataSearch = {
                    fcCode: localStorage.getItem("fcCode") || "",
                    whCode: localStorage.getItem("whCode") || "",
                    ppCode: "",
                    address: "",
                    matCode: "",
                    matName: "",
                    boxBarcode: "",
                    date: [],
                };
                //this.getProductPullList();
            },

            //标签补打
            rePrintBarcode() {

                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }

                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {

                    this.checkListMain.forEach((returnData)=>{
                        //打印成品标签
                        var produceTime = moment(returnData.createTime).format("YYYYMMDD");

                        var batchNo = 'P' + returnData.opCode;

                        if (returnData.matSpecs == undefined) {
                            returnData.matSpecs = "";
                        }

                        //T/生产工单/箱号/物料号/数量/规值/批次/生产日期/高度/箱型
                        // var qrCode = "T/" + returnData.opCode + "/" + returnData.boxBarcode + "/" + returnData.matCode + "/" +
                        //     returnData.matQuan + "/" + returnData.matSpecs + "/" + batchNo +
                        //     "/" + produceTime + "/" + "/" + returnData.packCode;

                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        var qrCode = returnData.boxBarcode + "," + returnData.opCode + "," + returnData.whCode + "," +
                            returnData.matCode + "," + returnData.matQuan + "," + returnData.matSpecs +
                            "," + batchNo + "," + produceTime + "," + returnData.boxHeight + ",,,";

                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        var barcodeData = {
                            boxBarcode: returnData.boxBarcode,
                            prodCode: returnData.matCode,
                            prodName: returnData.matName,
                            batchNo: batchNo,
                            count: returnData.matQuan,
                            checkPerson: localStorage.getItem("empNumber"),
                            date: produceTime,
                            poCode: returnData.opCode,
                            matSpecs: returnData.matSpecs,
                            whCode: returnData.whCode,
                            qrCode: qrCode,
                            supply: "",
                            printTime: printTime,
                            packageCode: returnData.packageCode,
                            packCode: returnData.packCode,
                            com: returnData.com,
                        }

                        this.$printer.printWMSProductBarcode(barcodeData);


                        this.lazyNext = setTimeout(() => {
                            this.lazyNext = null
                        }, 5000)    
                    }) 
                }
            },

            /**
             * 打印
             */
            printProduct() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请选中打印单！",
                        type: "warning",
                    });
                    return
                }
                let pcade = [];
                this.checkList.forEach((item) => {
                    pcade.push(item.ppCode)
                })
                let listString = pcade.join(",")
                this.$http.request({
                        url: "/api/SplitMergeMatChange/getProductDetailPrint",
                        method: "GET",
                        params: {
                            ppCode: listString,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            console.log(resp.data.data)
                            if (resp.data.data != undefined) {
                                this.printDate = moment(resp.data.data[0].createTime).format("yyyy-MM-DD")
                                this.printData = resp.data.data
                                this.printCollect = resp.data.collect
                                this.printShow = true;
                            } else {
                                this.$message({
                                    message: "暂无明细数据！",
                                    type: "warning",
                                });
                                return
                            }

                        }
                    })
                    .catch((error) => {});


            },

            downLoadChooseFile2() {
                this.downloadChooseLoading = true;
                var ppCode = "";
                this.checkList.forEach((item) => {
                    ppCode += item.ppCode + ",";
                })
                var paramsObj = {
                    ppCode: ppCode || null,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/SplitMergeMatChange/getProductPullDetail',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoadChoose2(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },

            downLoadChoose2(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {

                    })
                    const tHeader = ['成品编号', '成品数量', '毛重', '通道', '箱号', '装车单号', '工单编号', '规值', '创建时间']
                    const filterVal = ['matCode', 'matQuan', 'pwWeight', 'whCode', 'boxBarcode', 'ppCode', 'opCode', 'matSpecs', 'createTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '成品箱'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "product_pull：导出成品箱记录"
                    this.systemLog();
                    this.downloadChooseLoading = false;
                })

            },

            downLoadChooseFile() {
                this.downloadChooseLoading = true;
                this.downLoadChoose(this.checkListMain || null);
            },
            //表格导出
            downLoadFile() {
                this.downLoading = true;
                let endPoint = "";
                this.endPointList.forEach((item) => {
                    endPoint += item + ","
                })
                var paramsObj = {
                    fcCode: this.prodTaskDetailSearch.fcCode || null,
                    matCode: this.prodTaskDetailSearch.matCode || null,
                    boxBarcode: this.prodTaskDetailSearch.boxBarcode || null,
                    //endPoint: this.prodTaskDetailSearch.endPoint || null,
                    endPoint: endPoint || null,
                    status: this.prodTaskDetailSearch.status || null,
                    taskType: this.prodTaskDetailSearch.taskType || null,
                    delivery: this.prodTaskDetailSearch.delivery || null,
                    whCode: this.prodTaskDetailSearch.whCode || null,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/prodTask/getProdTaskDetail',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoadChoose(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoadChoose(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.delivery == '10') {
                            c['delivery'] = 'AGV配送'
                        } else if (c.delivery == '20') {
                            c['delivery'] = '人工配送'
                        }

                        if (c.status == 'CREATE') {
                            c['status'] = '创建'
                        } else if (c.status == 'COMPLETE') {
                            c['status'] = '待装车'
                        } else if (c.status == 'DELIVERY') {
                            c['status'] = '待确认完成'
                        } else if (c.status == 'EXECUTE') {
                            c['status'] = '搬运中'
                        }

                        if (c.endPoint == '1${02}') {
                            c['endPoint'] = '一期成品二层箱'
                        } else if (c.endPoint == '2${02}') {
                            c['endPoint'] = '一期成品一层箱'
                        } else if (c.endPoint == '3${02}') {
                            c['endPoint'] = '大托盘'
                        } else if (c.endPoint == '4${02}') {
                            c['endPoint'] = '二期蓝色一层箱'
                        } else if (c.endPoint == '5${02}') {
                            c['endPoint'] = '二期成品二层箱'
                        } else if (c.endPoint == '6${02}') {
                            c['endPoint'] = '二期成品一层箱'
                        }

                    })
                    const tHeader = ['工单编号', '成品编号', '成品数量', '箱号', '围板箱编码', '包装方式', '规值', '创建时间', '通道编号', '搬运起点', '搬运终点', '配送方式', '状态']
                    const filterVal = ['opCode', 'matCode', 'matQuan', 'boxBarcode', 'packCode', 'packageCode', 'matSpecs', 'createTime', 'whCode', 'startPoint', 'endPoint', 'delivery', 'status']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '成品箱'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "product_pull：导出成品箱记录"
                    this.systemLog();
                    this.downLoading = false;
                })
            },

            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "成品装车",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            this.getSysMaterial();
            this.getSysPointRouterAutoArea();
            this.getSysWarehouseAll();
            /* 获取首页的数据 */
            //this.getProductPullList();
            this.getProdTaskDetailList();
        },
    };
</script>

<style scoped>
    .div {
        width: 600px;
        height: 100%;
        /* border: 1px solid black; */
        margin-top: 107px;
        margin-left: 30px;
        margin-bottom: 100px;
        text-align: center
    }

    .div table th {
        width: 100px;
        height: 30px;
        border: 1px solid black;
        background: rgb(201, 197, 197);
        color: rgb(14, 13, 13);
    }

    .div table td {
        width: 100px;
        height: 30px;
        /* border: 1px solid black; */
        color: rgb(14, 13, 13);
    }

    .div1 table th {
        width: 100px;
        height: 30px;
        /* border: 1px solid black; */
        /* background: rgb(201, 197, 197); */
        color: rgb(14, 13, 13);
    }

    .div1 table td {
        width: 100px;
        height: 30px;
        /* border: 1px solid black; */
        color: rgb(14, 13, 13);
    }


    .div1 {
        width: 400px;
        height: 500px;
        /* border: 1px solid black; */
        /* margin-left: 700px;
        margin-top: -500px; */
        text-align: left;
        position: absolute;
        left: 700px;
        top: 100px;
    }

    .div1 div {
        width: 100px;
        height: 30px;
        /* border: 1px solid black; */
        color: black;
        font-size: 16px;
        font-weight: bold;
    }

    .demo11 {
        width: 100%;
        height: 100%;
        border: 1px solid white;
    }
</style>